/**
 * Listen to changes to the Recipe notes textarea and save it
 */
export default class RecipeNotes {
	/**
	 * Invokes method to listen to the Textarea field
	 * 
	 * @return {undefined}
	 */
	constructor() {
		document.getElementById( 'uap-notes-metabox__textarea' ).addEventListener( 'input', event => { 
			this.hasUnsavedData = true;
		} );

		document.getElementById( 'uap-notes-metabox__textarea' ).addEventListener( 'blur', event => {
			// Save only if the value changed
			if ( this.hasUnsavedData ) {
				UncannyAutomator._core.recipe.setRecipeNotes( event.target.value )
					.then( ( response ) => {
						this.hasUnsavedData = false;
					} );
			}
		} );
	}
}
